<template>
    <div v-if="visible" class="modal-mask">
        <div class="modal-video">
            <a href="" class="modal-close" @click.prevent="visible=false"></a>
            <iframe
                class="modal-iframe"
                :src="`https://www.youtube.com/embed/${youtubeCode}?autoplay=1`"
                frameborder="0"
                allowfullscreen
            ></iframe>
        </div>
    </div>
</template>

<script>
  export default {
    props: ['youtubeCode'],
    data() {
      return {
        visible: false
      }
    },
    events: {
      videoOpen() {
        this.visible = true
      }
    },
    mounted() {
      this.$root.$on('videoOpen', () => this.visible = true);
    }
  }
</script>
